module.exports = __webpack_public_path__ + "static/sem-e855cc5a8d01ce0b17eefc67037d28a4.svg";